export default __webpack_public_path__ + "static/media/Ballroll_00341.fdffec29.png";